import React, { useContext } from "react";
import sld from "../../images/sld/Rectangle.svg";
import { DesignAssetContext } from "../CustomHooks/ContextApi";
import Ecc from "../../components/OFFGrid/Ecc";
import Busbar from "../../components/OFFGrid/Busbar";
import Genset from "../../components/OFFGrid/Genset";
import PV from "../../components/OFFGrid/PV";
import Battery from "../../components/OFFGrid/Battery";
import LoadPvBess from "../../components/OFFGrid/LoadPvBess";
const OffGridSLD = () => {
    const contextValue = useContext(DesignAssetContext) || {};
    const {
        CBAssetList = [],
        CBLoadList = [],
        sldLoadCompleted,
        count = {},
    } = contextValue;
    console.log("OffGridSLD count:", count);
    const isAssetEnabled = (index) => Boolean(CBAssetList?.[index]?.uiData?.status);

    const areAllConfigured = () => {
        return CBLoadList.every((item) => Boolean(item?.uiData?.configured));
    };

    const loadXPosition = () =>{
        let xPosition = 0;
        if (count?.derCount === 2) {
            xPosition = 110;
        }else if (count?.derCount === 3) {
            xPosition += 170;
        }else if (count?.derCount === 4) {
            xPosition += 220;
        }else if (count?.derCount === 5) {
            xPosition += 290;
        }
        return xPosition;
    };

    const sldShiftX = count?.derCount === 6 ? -80 : count?.derCount === 5 ? -60 : 0;

    const assetSlots = [
        { id: "battery", assetIndex: 2 },
        { id: "genset", assetIndex: 1 },
        { id: "pv1", assetIndex: 3 },
        { id: "pv2", assetIndex: 4 },
        { id: "pv3", assetIndex: 5 },
    ];

    const enabledSlotsInOrder = assetSlots.filter((slot) => isAssetEnabled(slot.assetIndex));

    const slotPitchX = 110;
    const startX = 0;

    const assetXById = enabledSlotsInOrder.reduce((acc, slot, i) => {
        acc[slot.id] = startX + i * slotPitchX;
        return acc;
    }, {});

    return (
        <div
            id="SLD-Image"
            className="col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0"
        >
            <svg viewBox="0 0 1300 800">
                <g>
                    <svg x={count?.derCount === 2?60:0} y="0" viewBox="0 0 1300 800">
                        <g id="grid">
                            <svg>
                                <image href={sld} x="0" y="0" />
                            </svg>
                        </g>
                        <svg x={sldShiftX}>
                            <g
                                id="components-sld"
                                style={sldLoadCompleted ? {} : { display: "none" }}
                            >
                                <Ecc />
                                <svg x="365" y="130">
                                    <svg x="0" y="26"><Busbar /></svg>
                                    {isAssetEnabled(2) && <svg x={assetXById.battery ?? 0} y="0"><Battery /></svg>}
                                    {isAssetEnabled(1) && <svg x={assetXById.genset ?? 0} y="0"><Genset /></svg>}
                                    {isAssetEnabled(3) && <svg x={assetXById.pv1 ?? 0} y="0"><PV index={3} cx={100} cy={-130}/></svg>}
                                    {isAssetEnabled(4) && <svg x={assetXById.pv2 ?? 0} y="0"><PV index={4} cx={100} cy={-130}/></svg>}
                                    {isAssetEnabled(5) && <svg x={assetXById.pv3 ?? 0} y="0"><PV index={5} cx={100} cy={-130}/></svg>}
                                    <svg
                                        id="load-pointer1"
                                        x={loadXPosition()}
                                        y="226"
                                    >
                                        {CBLoadList.length > 0 && (
                                            <LoadPvBess
                                                loadLength={count}
                                                configured={areAllConfigured()}
                                                isEVThere={false}
                                            />
                                        )}
                                    </svg>

                                </svg>
                            </g>
                        </svg>
                    </svg>
                </g>
            </svg>
        </div>
    );
};

export default OffGridSLD;
